export default {
	cardTypes: [{
			value: "None",
			label: "ohne Bahncard"
		},
		{
			value: "BC25_1",
			label: "BC25_1"
		},
		{
			value: "BC25_2",
			label: "BC25_2"
		},
		{
			value: "BC50_1",
			label: "BC50_1"
		},
		{
			value: "BC50_2",
			label: "BC50_2"
		},
		{
			value: "BB25_1",
			label: "BB25_1"
		},
		{
			value: "BB25_2",
			label: "BB25_2"
		},
		{
			value: "BB50_1",
			label: "BB50_1"
		},
		{
			value: "BB50_2",
			label: "BB50_2"
		},
		{
			value: "AVTC",
			label: "AVTC"
		},
		{
			value: "CHGABO",
			label: "CHGABO"
		},
		{
			value: "CHHMRP",
			label: "CHHMRP"
		},
		{
			value: "CHHORP",
			label: "CHHORP"
		},
		{
			value: "NLVMPRP",
			label: "NLVMPRP"
		},
		{
			value: "NLVORP",
			label: "NLVORP"
		}
	]
}